import { PageHero, SHELL, Reveal, Mono } from "@/components/bits";
import { POOLS } from "@/lib/data";

const ROWS = [
    ["TARGET STRUCTURE", "structure"],
    ["ASSET TYPE", "assetType"],
    ["MATURITY", "maturity"],
    ["LIQUIDITY", "liquidity"],
    ["VERIFICATION", "verification"],
];

export default function Pools() {
    return (
        <div data-testid="pools-page">
            <PageHero
                label="CAPITAL LAYER"
                title={"CAPITAL, STRUCTURED ONCHAIN."}
                sub="VERA Pools aggregate verified assets and their economic cash flows into programmable financial structures — shared accounting, structured exposure, one programmable interface for capital."
            />
            <section className="py-20 md:py-28">
                <SHELL>
                    <Reveal>
                        <div className="flex items-center gap-3 mb-10" data-testid="pools-conceptual-note">
                            <span className="w-2 h-2 rotate-45 border border-vera-gold" aria-hidden="true" />
                            <Mono className="text-vera-mut">CONCEPTUAL STRUCTURES — NO APY, TVL OR LIVE METRICS ARE PUBLISHED</Mono>
                        </div>
                    </Reveal>
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-16">
                        {POOLS.map((p, i) => (
                            <Reveal key={p.id} delay={i * 0.05}>
                                <div className="glass-card p-7 h-full hover:border-vera-blue/40 transition-colors" data-testid={`pool-card-${p.id}`}>
                                    <div className="flex items-center justify-between mb-7">
                                        <span className="font-mono text-[10px] text-vera-gold">{String(i + 1).padStart(2, "0")}</span>
                                        <span className="font-mono text-[9px] tracking-[0.2em] text-vera-mut border border-white/15 px-2 py-0.5">CONCEPT</span>
                                    </div>
                                    <h3 className="font-bold tracking-wide text-base mb-7 min-h-[2.5rem]">{p.name}</h3>
                                    <dl>
                                        {ROWS.map(([label, key]) => (
                                            <div key={key} className="flex items-center justify-between gap-3 py-2.5 border-b border-white/5">
                                                <dt className="font-mono text-[9px] tracking-[0.2em] text-vera-mut">{label}</dt>
                                                <dd className="font-mono text-[10px] tracking-[0.15em] text-vera-white text-right">{p[key]}</dd>
                                            </div>
                                        ))}
                                    </dl>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                    <Reveal>
                        <p className="text-[11px] text-vera-mut/70 leading-relaxed max-w-3xl">
                            The pool architecture is built so that real onchain data can be connected later through the protocol's configuration layer.
                            Until then, these structures are shown conceptually. No returns, yields or performance figures are promised or implied.
                        </p>
                    </Reveal>
                </SHELL>
            </section>
        </div>
    );
}
